import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { Button, Modal, Col, Row, Spinner, Form } from "react-bootstrap";
import _ from "lodash";
import { useForm, Controller } from "react-hook-form";
import { NumericFormat, PatternFormat } from "react-number-format";
import ApiSupplier from "../../../core/api/api.supplier";
import { DateObject } from "react-multi-date-picker";
import { persian, customLocale } from "../_Components/customLocale";
import ApiBasketItemPerson from "../../../core/api/api.basketItemPerson";
import { tools } from "../../../core/utils/tools";
import SwalMessage from "../_Components/SwalMessage";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import SelectComponent from "../_Components/ReactSelectComponent";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/CloseRounded";

const PayToWarrantyModal2 = ({ showModalWarranty2, setShowModalWarranty2, formData }) => {
  const fieldLabels = {
    amusementServiceIds: "تفریح",
    amusementServiceReserveItemGroupIds: "گروه آیتم‌ها",
    amusementServiceReserveItemIds: "آیتم‌ها",
    createTimeOf: "زمان ایجاد از",
    createTimeTo: "زمان ایجاد تا",
    useTimeOf: "زمان انجام تفریح از",
    useTimeTo: "زمان انجام تفریح تا",
    currentStatus: "وضعیت سفارش",
    cancelStatus: "وضعیت کنسل",
    firstName: "نام",
    lastName: "نام خانوادگی",
    phoneNumber: "شماره موبایل",
    promoCode: "کد تخفیف",
    originalPrice: "نرخ مصوب",
    salePrice: "نرخ فروش",
    basketItemPersonOf: "شماره بلیط از",
    basketItemPersonTo: "شماره بلیط تا",
    basketIdOf: "شماره سفارش از",
    basketIdTo: "شماره سفارش تا",
    payToWarrantyCount: "پرداخت به تامین کننده",
    receiveFromWarrantyCount: "دریافت از تامین کننده",
    payOrReceiveWarrantyTimeOf: "زمان پرداخت از",
    payOrReceiveWarrantyTimeTo: "زمان پرداخت تا",
    supplierId: "تامین کننده",
    //totalCount :"تعداد کل بلیط ها"
    cityIds: "شهر",
    amusementGroupIds: "دسته تفریح",
  };
  const excludedFields = ["pageSize", "totalPages", "pageNumber", "totalCount"];
  //SelectComponent حفظ ساختار اصلی برای فیلدهای
  const multiSelectFields = [
    "amusementServiceIds",
    "amusementServiceReserveItemGroupIds",
    "amusementServiceReserveItemIds",
    "currentStatus",
    "cancelStatus",
  ];
  const singleSelectFields = ["promoCode", "payToWarrantyCount", "receiveFromWarrantyCount", "supplierId"];
  const prepareDefaultValues = (data) => {
    return Object.entries(data).reduce((acc, [key, value]) => {
      if (multiSelectFields.includes(key)) {
        acc[key] = Array.isArray(value) ? value : value ? [value] : [];
      } else if (singleSelectFields.includes(key)) {
        acc[key] = value && typeof value === "object" ? value : null;
      } else {
        acc[key] = value || "";
      }

      return acc;
    }, {});
  };
  const displaySingleSelectValue = (value) => {
    if (!value) return "-";
    if (typeof value === "object") {
      return value.label || value.name || value.title || value.id || "";
    }
    return value.toString();
  };
  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 10000,
    }),
  };
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting: isSubmittingForm },
    setValue,
    getValues,
    register,
    watch,
  } = useForm({ defaultValues: prepareDefaultValues(formData) });

  const [suppliers, setSuppliers] = useState();

  // تایمر برای نشان دادن پیغام های لازم
  const [saveMessage, setSaveMessage] = useState("");
  const [showSaveMessage, setShowSaveMessage] = useState(false);
  const [timeForSubmitButton, setTimeForSubmitButton] = useState(0); // timer for get agine cod
  // set timer
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (timeForSubmitButton > 0) {
        setTimeForSubmitButton(timeForSubmitButton - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  //تاریخ و ساعت الان
  const setDefaultDateAndTime = () => {
    const date = new Date();
    const shamsiDate = new DateObject({ calendar: persian, locale: customLocale });
    const hour = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const time = `${hour}:${minutes}`; // ##:## format
    return { shamsiDate, time };
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const suppliers = await ApiSupplier.getAllSuppliersName(); // Fetch all suppliers
        setSuppliers(suppliers);

        // تنظیم تاریخ و زمان فعلی
        const { shamsiDate, time } = setDefaultDateAndTime();
        setValue("time", time);
        //چک خالی نبودن آیتم ها
        if (
          _.isEmpty(formData.createTimeOf) &&
          _.isEmpty(formData.createTimeTo) &&
          _.isEmpty(formData.useTimeOf) &&
          _.isEmpty(formData.useTimeTo)
        ) {
          setShowSaveMessage(true);
          setSaveMessage("هیچ بازه ای انتخاب نشده است.");
          setTimeForSubmitButton(8);
        }
        if (_.isEmpty(formData.amusementServiceIds)) {
          setShowSaveMessage(true);
          setTimeForSubmitButton(8);
          setSaveMessage((prev) => (prev ? `${prev} | هیچ تفریحی انتخاب نشده است.` : "هیچ تفریحی انتخاب نشده است."));
        }
        if (_.isEmpty(formData.originalPrice) && _.isEmpty(formData.salePrice)) {
          setShowSaveMessage(true);
          setTimeForSubmitButton(8);
          setSaveMessage((prev) =>
            prev
              ? `${prev} | ممکن است تفریحات با مبالغ یکسان انتخاب نشده باشند.`
              : "ممکن است تفریحات با مبالغ یکسان انتخاب نشده باشند.",
          );
        }
      } catch (error) {
      }
    };
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    data.supplierId = data.supplierId?.value;
    data.promoCode = data.promoCode?.value;
    data.payToWarrantyCount = data.payToWarrantyCount?.value;
    data.receiveFromWarrantyCount = data.receiveFromWarrantyCount?.value;

    data.cancelStatus = data.cancelStatus?.length > 0 ? _.toString(data.cancelStatus?.map((item) => item.value)) : null;
    data.currentStatus =
      data.currentStatus?.length > 0 ? _.toString(data.currentStatus?.map((item) => item.value)) : null;

    data.amusementServiceIds =
      data.amusementServiceIds?.length > 0 ? _.toString(data.amusementServiceIds?.map((item) => item.value)) : null;
    data.amusementServiceReserveItemGroupIds =
      data.amusementServiceReserveItemGroupIds?.length > 0
        ? _.toString(data.amusementServiceReserveItemGroupIds?.map((item) => item.value))
        : null;
    data.amusementServiceReserveItemIds =
      data.amusementServiceReserveItemIds?.length > 0
        ? _.toString(data.amusementServiceReserveItemIds?.map((item) => item.value))
        : null;

    data.warrantyPaymentSupplierId = data?.warrantyPaymentSupplierId?.value;
    data.warrantyPaymentAmount =
      data.warrantyPaymentAmount && data.warrantyPaymentAmount.length > 0
        ? data.warrantyPaymentAmount.replaceAll(" ", "").replaceAll(",", "")
        : data.price;
    if (data.paymentDate !== null && typeof data.paymentDate === "object")
      data.paymentDate = tools.DateFormat(data.paymentDate);
    try {
      const response = await ApiBasketItemPerson.PayToWaranty2(data);
      SwalMessage({ title: response.message, iSsuccess: response.succeeded, timer: 4000 });
      if (response.succeeded) {
        setShowModalWarranty2(false);
      }
    } catch (error) {
    }
  };

  return (
    <Modal show={showModalWarranty2} onHide={() => setShowModalWarranty2(false)} size="lg">
      <Modal.Header closeButton>
        <Modal.Title> پرداخت به تامین کننده</Modal.Title>
      </Modal.Header>
      <Form id="form" onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <div className=" rounded-3 py-3 px-4" style={{ border: "1px solid #ccc" }}>
            {
              <div className="fw-bold  border-bottom pb-3 mb-3">
                تعداد کل بلیط های انتخاب شده: {formData.totalCount}
              </div>
            }
            <Row>
              {Object.entries(formData)
                .filter(([key, value]) => {
                  // حذف فیلدهای سیستمی
                  if (excludedFields.includes(key)) return false;

                  // فقط فیلدهای پر شده
                  return (
                    value !== null &&
                    value !== undefined &&
                    value !== "" &&
                    !(Array.isArray(value) && value.length === 0)
                  );
                })
                .map(([key, value]) => (
                  <Col xs="6" sm="4" lg="3" key={key} className="mb-5">
                    <div className="fw-bold opacity-50 mb-1">{fieldLabels[key] || key}</div>
                    <div>
                      {singleSelectFields.includes(key)
                        ? displaySingleSelectValue(value)
                        : Array.isArray(value)
                          ? value.map((v) => displaySingleSelectValue(v)).join("، ")
                          : value?.toString() || "-"}
                    </div>
                  </Col>
                ))}
            </Row>
          </div>
          <Row>
            <Col xs="12">
              <Controller
                name="warrantyPaymentSupplierId"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange } }) => (
                  <SelectComponent
                    name="warrantyPaymentSupplierId"
                    style={selectStyles}
                    inputId="react-select-with-search"
                    className="w-100 mt-5"
                    variant="outlined"
                    size="small"
                    placeholder="تامین کننده"
                    TextFieldProps={{
                      label: "Supplier",
                      InputLabelProps: {
                        htmlFor: "react-select-multiple",
                        shrink: true,
                      },
                    }}
                    options={suppliers?.map((item) => ({
                      value: item.id,
                      label: item.companyName,
                    }))}
                    value={getValues("warrantyPaymentSupplierId") || ""}
                    onChange={onChange}
                  />
                )}
              />
              {errors.warrantyPaymentSupplierId && (
                <div className="mt-2 pl-4 text-danger">**لطفا تامین کننده را وارد نمایید.</div>
              )}
            </Col>
            <Col xs="12">
              <Controller
                name="warrantyPaymentAmount"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <NumericFormat
                    customInput={TextField}
                    label="مبلغ پرداخت به تامین کننده"
                    margin="normal"
                    type="search"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onChange={onChange}
                    thousandSeparator=","
                    onKeyDown={(e) => {
                      if (e.key === "Escape") {
                        e.stopPropagation()
                      }
                    }}
                  />
                )}
              />
              {errors.warrantyPaymentAmount && (
                <div className="mt-2 pl-4 text-danger">**لطفا مبلغ پرداخت به تامین کننده را وارد نمایید.</div>
              )}
            </Col>
            <Col xs="12" className="mt-5 mb-3">
              <div className="d-lg-flex align-items-center flex-wrap">
                <label className="font-weight-bold mb-0 mr-3">تاریخ پرداخت به تامین کننده:</label>
                <div className="d-sm-flex align-items-center flex-wrap">
                  <div className="form-check mr-4 ">
                    <input
                      className="form-check-input my-3"
                      type="radio"
                      name="dateOption"
                      id="activityDate"
                      value="1"
                      defaultChecked
                      {...register("dateOption")}
                      onChange={(e) => {
                        setValue("dateOption", e.target.value);
                        if (e.target.value === "1") {
                          setValue("paymentDate", null);
                        }
                      }}
                    />
                    <label className="form-check-label my-3" htmlFor="activityDate">
                      تاریخ انجام تفریح
                    </label>
                  </div>
                  <div className="form-check d-flex align-items-center ">
                    <input
                      className="form-check-input my-3"
                      type="radio"
                      name="dateOption"
                      id="todayDate"
                      value="2"
                      {...register("dateOption")}
                      onChange={(e) => {
                        setValue("dateOption", e.target.value);
                        if (e.target.value === "2") {
                          const today = tools.getShamsiDateTime();
                          setValue("paymentDate", today.shamsiDate);
                        }
                      }}
                    />
                    <label className="form-check-label my-3 mr-3" htmlFor="todayDate">
                      تاریخ
                    </label>
                    {watch("dateOption") === "2" && (
                      <div className="d-inline-block mr-3">
                        <Controller
                          name="paymentDate"
                          control={control}
                          render={({ field: { onChange, value } }) => (
                            <ShamsiDatePicker
                              value={value}
                              onChange={onChange}
                              // placeholder="تاریخ پرداخت"
                              className="form-control w-100 py-1"
                            />
                          )}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Col>

            <Col xs="12" className="mt-5">
              <Controller
                name="time"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <div>
                    <PatternFormat
                      customInput={TextField}
                      format="##:##"
                      type="search"
                      onKeyDown={(e) => {
                        if (e.key === "Escape") {
                          e.stopPropagation()
                        }
                      }}
                      name="time"
                      value={value || ""}
                      onChange={onChange}
                      variant="outlined"
                      className={
                        errors["time"]
                          ? "border border-danger floating-input form-control  w-100"
                          : "floating-input form-control  w-100"
                      }
                      placeholder="00:00"
                    />
                    <label className="floating-label text-secondary">ساعت انجام تراکنش</label>
                  </div>
                )}
              />
            </Col>

            <Col xs="12" className="mt-5">
              <Controller
                name="description"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <div className="floating-label-content postion-relative">
                    <textarea
                      placeholder=""
                      value={value || ""}
                      className={`floating-input form-control min-width-textarea w-100`}
                      onChange={onChange}
                      onKeyDown={(e) => {
                        if (e.key === "Escape") {
                          const input = e.target;
                          if (input?.disabled) return
                          if (input) input.value = null;
                          const ev = new Event("input", { bubbles: true });
                          input.dispatchEvent(ev);
                          e.stopPropagation()
                        }
                      }}
                    />
                    <label className="floating-label text-secondary ">توضیحات</label>
                    <IconButton
                      type="button"
                      style={{
                        left: 20
                      }}
                      className="position-absolute top-50 translate-middle w-auto"
                      onClick={(e) => {
                        const input = e.currentTarget.closest(".floating-label-content").querySelector("textarea");
                        if (input?.disabled || input?.readOnly) return
                        if (input) input.value = null;
                        const ev = new Event("input", { bubbles: true });
                        input.dispatchEvent(ev);
                      }}
                      size="small"
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </div>
                )}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-block">
          <div>
            {showSaveMessage && <div className=" rounded-3 text-danger bg-light-danger p-3 mb-3">{saveMessage}</div>}
          </div>

          <div>
            <Button
              variant="success"
              disabled={(timeForSubmitButton > 0 ? "disabled" : "") || isSubmittingForm}
              type="submit"
              className="mx-1"
            >
              {isSubmittingForm && <Spinner animation="border" variant="warning" size="sm" />}
              {timeForSubmitButton > 0 ? (
                <>
                  <span> تایید و ارسال</span>
                  <span className="d-inline-block" style={{ width: "20px" }}>
                    {timeForSubmitButton}{" "}
                  </span>
                </>
              ) : (
                " تایید و ارسال "
              )}
            </Button>{" "}
            <Button variant="secondary" onClick={() => setShowModalWarranty2(false)}>
              انصراف
            </Button>
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
export default PayToWarrantyModal2;
